/** Bounded, session-local card interaction trace. */
let MoonfallActionTrace;

(function () {
  'use strict';

  if (typeof window === 'undefined' || MoonfallActionTrace) return;

  var PREFIX = '[CardActionTrace] ';
  var DUMP_PREFIX = '[CardActionTraceDump] ';
  var MAX_ENTRIES = 160;
  var MAX_STRING = 240;
  var entries = [];
  var open = new Map();
  var latestBySource = new Map();
  var sequence = 0;
  var traceSequence = 0;

  function truncate(value) {
    var text = String(value == null ? '' : value);
    return text.length > MAX_STRING ? text.slice(0, MAX_STRING) : text;
  }

  function blockedKey(key) {
    if (key === 'socketConnected') return false;
    return /(?:auth|token|secret|cookie|email|room|user|session|connection|socketId)/i.test(key);
  }

  function sanitize(value, depth) {
    if (depth > 3 || value == null) return value == null ? null : undefined;
    if (typeof value === 'string') return truncate(value);
    if (typeof value === 'number' || typeof value === 'boolean') return value;
    if (Array.isArray(value)) {
      return value.slice(0, 8).map(function (item) { return sanitize(item, depth + 1); })
        .filter(function (item) { return item !== undefined; });
    }
    if (typeof value !== 'object') return truncate(value);

    var clean = {};
    Object.keys(value).slice(0, 24).forEach(function (key) {
      if (blockedKey(key)) return;
      var sanitized = sanitize(value[key], depth + 1);
      if (sanitized !== undefined) clean[key] = sanitized;
    });
    return clean;
  }

  function write(entry) {
    entries.push(entry);
    while (entries.length > MAX_ENTRIES) entries.shift();
    try { console.info(PREFIX + JSON.stringify(entry)); } catch (_) { /* no-op */ }
    return entry;
  }

  function nextTraceId() {
    traceSequence += 1;
    return 'ca-' + Date.now().toString(36) + '-' + traceSequence.toString(36);
  }

  function record(traceId, eventName, details, terminal) {
    var context = open.get(traceId);
    if (!context) return null;
    sequence += 1;
    var entry = Object.assign({
      t: Date.now(),
      seq: sequence,
      traceId: traceId,
      event: truncate(eventName || 'unknown'),
      sourceCardId: context.sourceCardId,
      elapsedMs: Math.max(0, Date.now() - context.startedAt),
    }, sanitize(details || {}, 0));
    if (terminal) entry.terminal = true;
    return write(entry);
  }

  function discardOpen(traceId) {
    var context = open.get(traceId);
    if (!context) return;
    open.delete(traceId);
    if (latestBySource.get(context.sourceCardId) === traceId) {
      latestBySource.delete(context.sourceCardId);
    }
  }

  function pruneOpen() {
    while (open.size >= MAX_ENTRIES) {
      var oldest = open.keys().next().value;
      discardOpen(oldest);
    }
  }

  function start(sourceCardId, details, eventName) {
    pruneOpen();
    var traceId = nextTraceId();
    var context = {
      sourceCardId: truncate(sourceCardId || 'unknown'),
      startedAt: Date.now(),
    };
    open.set(traceId, context);
    latestBySource.set(context.sourceCardId, traceId);
    record(traceId, eventName || 'pointerdown-accepted', details);
    return traceId;
  }

  function finish(traceId, eventName, details) {
    var context = open.get(traceId);
    if (!context) return null;
    var entry = record(traceId, eventName, details, true);
    discardOpen(traceId);
    return entry;
  }

  function instant(sourceCardId, eventName, details) {
    var traceId = start(sourceCardId, {}, 'pointer-attempt');
    finish(traceId, eventName, details);
    return traceId;
  }

  function findOpen(sourceCardId) {
    var traceId = latestBySource.get(truncate(sourceCardId || 'unknown'));
    return traceId && open.has(traceId) ? traceId : null;
  }

  function snapshot() {
    return JSON.parse(JSON.stringify(entries));
  }

  function snapshotJson() {
    return JSON.stringify(snapshot());
  }

  function dump() {
    var json = snapshotJson();
    try { console.info(DUMP_PREFIX + json); } catch (_) { /* no-op */ }
    return json;
  }

  MoonfallActionTrace = {
    start: start,
    record: record,
    finish: finish,
    instant: instant,
    findOpen: findOpen,
    snapshot: snapshot,
    snapshotJson: snapshotJson,
    dump: dump,
    clear: function () {
      entries.length = 0;
      open.clear();
      latestBySource.clear();
    },
  };
})();

export { MoonfallActionTrace };
